import { IconError, IconTaskAlt, IconWarning } from '@genesis/icons';
import { Toaster as Sonner } from 'sonner';

import { cn } from '@/app/utils/cn';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const SuccessIcon = () => <IconTaskAlt aria-hidden className='fill-fill-success size-5' />;

const FailIcon = () => <IconError aria-hidden className='fill-fill-critical size-5' />;

const WarningIcon = () => <IconWarning aria-hidden className='fill-fill-warning size-5' />;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      {...props}
      richColors
      visibleToasts={2}
      className='toaster group'
      position='top-center'
      icons={{
        error: <FailIcon />,
        success: <SuccessIcon />,
        warning: <WarningIcon />,
      }}
      toastOptions={{
        duration: 5000,
        classNames: {
          toast: cn(
            'group toast group-[.toaster]:bg-surface-neutral-primary group-[.toaster]:text-content-neutral-primary group-[.toaster]:border-border-neutral group-[.toaster]:shadow-lg',
          ),
          title: cn('group-[.toast]:text-content-neutral-primary'),
          description: cn('group-[.toast]:text-content-neutral-secondary'),
        },
      }}
    />
  );
};

export { Toaster };
